import { useMutation, useQueryClient } from '@tanstack/react-query';
import { chatApi } from '../api/chat.api';
import { chatKeys } from '../api/chat.keys';
import toast from 'react-hot-toast';

export function useDeleteChatRoom() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: any) => chatApi.deleteRoom(id),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: chatKeys.rooms });
      toast.success('Chat room deleted');
    },
    onError: (err: any) => {
      toast.error(err.response?.data?.message || 'Failed to delete chat room');
    },
  });
}

export function useDeleteMessage() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: any) => chatApi.deleteMessage(id),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: chatKeys.messages });
      toast.success('Message deleted');
    },
    onError: (err: any) => {
      toast.error(err.response?.data?.message || 'Failed to delete message');
    },
  });
}
